import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'FollowRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'FollowRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'FollowRecord',
    column_type: 'datetime',
  },
  customer: {
    model_name: 'FollowRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  customer_id: {
    model_name: 'FollowRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  user: {
    model_name: 'FollowRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'FollowRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  followed_at: {
    model_name: 'FollowRecord',
    column_type: 'datetime',
  },
  task_assignment: {
    model_name: 'FollowRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'task_assignment',
      model_name: 'TaskAssignment',
    },
  },
  task_assignment_id: {
    model_name: 'FollowRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'task_assignment',
      model_name: 'TaskAssignment',
    },
  },
  content: {
    model_name: 'FollowRecord',
    column_type: 'text',
  },
  media: {
    model_name: 'FollowRecord',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  follow_key_items: {
    model_name: 'FollowRecord',
    column_type: 'has_many',
    extra: {
      association_name: 'follow_key_items',
      model_name: 'FollowKeyItem',
      foreign_key: 'follow_record_id',
    },
  },
  follow_key_item_ids: {
    model_name: 'FollowRecord',
    column_type: 'has_many',
    extra: {
      association_name: 'follow_key_items',
      model_name: 'FollowKeyItem',
      foreign_key: 'follow_record_id',
    },
  },
  can_update: {
    model_name: 'FollowRecord',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'FollowRecord',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
